import { AgencyDto } from "app/shared/models/agency.model";
import { MultiselectSettings } from "../core/multiselect-settings.model";

export class DuplicateCartAgencies {
  disabled?: boolean;
  data?: AgencyDto[];
  selected?: AgencyDto;
  settings: MultiselectSettings<AgencyDto>;
  constructor(init?: DuplicateCartAgencies) {
    Object.assign(this, init);
  }
}
